/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as PlamaRouteImport } from './routes/_plama'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SchedulingRouteRouteImport } from './routes/scheduling/route'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedCallTimesRouteImport } from './routes/_authed/call-times'
import { Route as AuthedEwcCalendarRouteImport } from './routes/_authed/ewc-calendar'
import { Route as AuthedFanPicsRouteRouteImport } from './routes/_authed/fan-pics/route'
import { Route as AuthedFilenamesRouteRouteImport } from './routes/_authed/filenames/route'
import { Route as AuthedMediaDayRouteImport } from './routes/_authed/media-day'
import { Route as AuthedScannerAuthRouteImport } from './routes/_authed/scanner-auth'
import { Route as AuthedStaffPhotoShootsRouteImport } from './routes/_authed/staff-photo-shoots'
import { Route as AuthedUsersRouteRouteImport } from './routes/_authed/users/route'
import { Route as PlamaPlamaRouteImport } from './routes/_plama/plama'
import { Route as SchedulingIndexRouteImport } from './routes/scheduling/index'
import { Route as SchedulingCalendarRouteImport } from './routes/scheduling/calendar'
import { Route as SchedulingConfirmRouteImport } from './routes/scheduling/confirm'
import { Route as AuthedAnalyticsWorkTimeRouteImport } from './routes/_authed/analytics.work-time'
import { Route as AuthedCallTimesDateRouteImport } from './routes/_authed/call-times.$date'
import { Route as AuthedFanPicsIndexRouteImport } from './routes/_authed/fan-pics/index'
import { Route as AuthedFanPicsQrCodesRouteImport } from './routes/_authed/fan-pics/qr-codes'
import { Route as AuthedFanPicsUploadsRouteImport } from './routes/_authed/fan-pics/uploads'
import { Route as AuthedFilenamesIndexRouteImport } from './routes/_authed/filenames/index'
import { Route as AuthedFilenamesGameTitlesRouteImport } from './routes/_authed/filenames/game-titles'
import { Route as AuthedFilenamesImportRouteImport } from './routes/_authed/filenames/import'
import { Route as AuthedFilenamesPlayersRouteImport } from './routes/_authed/filenames/players'
import { Route as AuthedFilenamesTeamsRouteImport } from './routes/_authed/filenames/teams'
import { Route as AuthedMediaDayDateRouteImport } from './routes/_authed/media-day.$date'
import { Route as AuthedPosesQrCodesRouteImport } from './routes/_authed/poses.qr-codes'
import { Route as AuthedPosesViewRouteImport } from './routes/_authed/poses.view'
import { Route as AuthedSettingDiscordRouteImport } from './routes/_authed/setting/discord'
import { Route as AuthedSettingScheduleRouteImport } from './routes/_authed/setting/schedule'
import { Route as AuthedSettingsSchedulingRouteImport } from './routes/_authed/settings/scheduling'
import { Route as AuthedStaffPhotoShootsDateRouteImport } from './routes/_authed/staff-photo-shoots.$date'
import { Route as AuthedStaffPhotoShootsWalkInsRouteImport } from './routes/_authed/staff-photo-shoots.walk-ins'
import { Route as AuthedUsersIndexRouteImport } from './routes/_authed/users/index'
import { Route as AuthedUsersAllowListRouteImport } from './routes/_authed/users/allow-list'
import { Route as AuthedUsersManageRouteImport } from './routes/_authed/users/manage'
import { Route as MediaDayStatusTokenRouteImport } from './routes/media-day.status.$token'
import { Route as SchedulingConfirmedTokenRouteImport } from './routes/scheduling/confirmed.$token'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const PlamaRoute = PlamaRouteImport.update({
  id: '/_plama',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoRoute = DemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SchedulingRouteRoute = SchedulingRouteRouteImport.update({
  id: '/scheduling',
  path: '/scheduling',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCallTimesRoute = AuthedCallTimesRouteImport.update({
  id: '/call-times',
  path: '/call-times',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedEwcCalendarRoute = AuthedEwcCalendarRouteImport.update({
  id: '/ewc-calendar',
  path: '/ewc-calendar',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFanPicsRouteRoute = AuthedFanPicsRouteRouteImport.update({
  id: '/fan-pics',
  path: '/fan-pics',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFilenamesRouteRoute = AuthedFilenamesRouteRouteImport.update({
  id: '/filenames',
  path: '/filenames',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMediaDayRoute = AuthedMediaDayRouteImport.update({
  id: '/media-day',
  path: '/media-day',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedScannerAuthRoute = AuthedScannerAuthRouteImport.update({
  id: '/scanner-auth',
  path: '/scanner-auth',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStaffPhotoShootsRoute = AuthedStaffPhotoShootsRouteImport.update({
  id: '/staff-photo-shoots',
  path: '/staff-photo-shoots',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedUsersRouteRoute = AuthedUsersRouteRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedRoute,
} as any)
const PlamaPlamaRoute = PlamaPlamaRouteImport.update({
  id: '/plama',
  path: '/plama',
  getParentRoute: () => PlamaRoute,
} as any)
const SchedulingIndexRoute = SchedulingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SchedulingRouteRoute,
} as any)
const SchedulingCalendarRoute = SchedulingCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => SchedulingRouteRoute,
} as any)
const SchedulingConfirmRoute = SchedulingConfirmRouteImport.update({
  id: '/confirm',
  path: '/confirm',
  getParentRoute: () => SchedulingRouteRoute,
} as any)
const AuthedAnalyticsWorkTimeRoute = AuthedAnalyticsWorkTimeRouteImport.update({
  id: '/analytics/work-time',
  path: '/analytics/work-time',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCallTimesDateRoute = AuthedCallTimesDateRouteImport.update({
  id: '/$date',
  path: '/$date',
  getParentRoute: () => AuthedCallTimesRoute,
} as any)
const AuthedFanPicsIndexRoute = AuthedFanPicsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedFanPicsRouteRoute,
} as any)
const AuthedFanPicsQrCodesRoute = AuthedFanPicsQrCodesRouteImport.update({
  id: '/qr-codes',
  path: '/qr-codes',
  getParentRoute: () => AuthedFanPicsRouteRoute,
} as any)
const AuthedFanPicsUploadsRoute = AuthedFanPicsUploadsRouteImport.update({
  id: '/uploads',
  path: '/uploads',
  getParentRoute: () => AuthedFanPicsRouteRoute,
} as any)
const AuthedFilenamesIndexRoute = AuthedFilenamesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedFilenamesRouteRoute,
} as any)
const AuthedFilenamesGameTitlesRoute =
  AuthedFilenamesGameTitlesRouteImport.update({
    id: '/game-titles',
    path: '/game-titles',
    getParentRoute: () => AuthedFilenamesRouteRoute,
  } as any)
const AuthedFilenamesImportRoute = AuthedFilenamesImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => AuthedFilenamesRouteRoute,
} as any)
const AuthedFilenamesPlayersRoute = AuthedFilenamesPlayersRouteImport.update({
  id: '/players',
  path: '/players',
  getParentRoute: () => AuthedFilenamesRouteRoute,
} as any)
const AuthedFilenamesTeamsRoute = AuthedFilenamesTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => AuthedFilenamesRouteRoute,
} as any)
const AuthedMediaDayDateRoute = AuthedMediaDayDateRouteImport.update({
  id: '/$date',
  path: '/$date',
  getParentRoute: () => AuthedMediaDayRoute,
} as any)
const AuthedPosesQrCodesRoute = AuthedPosesQrCodesRouteImport.update({
  id: '/poses/qr-codes',
  path: '/poses/qr-codes',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPosesViewRoute = AuthedPosesViewRouteImport.update({
  id: '/poses/view',
  path: '/poses/view',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingDiscordRoute = AuthedSettingDiscordRouteImport.update({
  id: '/setting/discord',
  path: '/setting/discord',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingScheduleRoute = AuthedSettingScheduleRouteImport.update({
  id: '/setting/schedule',
  path: '/setting/schedule',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsSchedulingRoute =
  AuthedSettingsSchedulingRouteImport.update({
    id: '/settings/scheduling',
    path: '/settings/scheduling',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedStaffPhotoShootsDateRoute =
  AuthedStaffPhotoShootsDateRouteImport.update({
    id: '/$date',
    path: '/$date',
    getParentRoute: () => AuthedStaffPhotoShootsRoute,
  } as any)
const AuthedStaffPhotoShootsWalkInsRoute =
  AuthedStaffPhotoShootsWalkInsRouteImport.update({
    id: '/walk-ins',
    path: '/walk-ins',
    getParentRoute: () => AuthedStaffPhotoShootsRoute,
  } as any)
const AuthedUsersIndexRoute = AuthedUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedUsersRouteRoute,
} as any)
const AuthedUsersAllowListRoute = AuthedUsersAllowListRouteImport.update({
  id: '/allow-list',
  path: '/allow-list',
  getParentRoute: () => AuthedUsersRouteRoute,
} as any)
const AuthedUsersManageRoute = AuthedUsersManageRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => AuthedUsersRouteRoute,
} as any)
const MediaDayStatusTokenRoute = MediaDayStatusTokenRouteImport.update({
  id: '/media-day/status/$token',
  path: '/media-day/status/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SchedulingConfirmedTokenRoute =
  SchedulingConfirmedTokenRouteImport.update({
    id: '/confirmed/$token',
    path: '/confirmed/$token',
    getParentRoute: () => SchedulingRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/scheduling': typeof SchedulingRouteRouteWithChildren
  '/': typeof AuthedIndexRoute
  '/demo': typeof DemoRoute
  '/login': typeof LoginRoute
  '/fan-pics': typeof AuthedFanPicsRouteRouteWithChildren
  '/filenames': typeof AuthedFilenamesRouteRouteWithChildren
  '/users': typeof AuthedUsersRouteRouteWithChildren
  '/call-times': typeof AuthedCallTimesRouteWithChildren
  '/ewc-calendar': typeof AuthedEwcCalendarRoute
  '/media-day': typeof AuthedMediaDayRouteWithChildren
  '/scanner-auth': typeof AuthedScannerAuthRoute
  '/staff-photo-shoots': typeof AuthedStaffPhotoShootsRouteWithChildren
  '/plama': typeof PlamaPlamaRoute
  '/scheduling/calendar': typeof SchedulingCalendarRoute
  '/scheduling/confirm': typeof SchedulingConfirmRoute
  '/scheduling/': typeof SchedulingIndexRoute
  '/analytics/work-time': typeof AuthedAnalyticsWorkTimeRoute
  '/call-times/$date': typeof AuthedCallTimesDateRoute
  '/fan-pics/qr-codes': typeof AuthedFanPicsQrCodesRoute
  '/fan-pics/uploads': typeof AuthedFanPicsUploadsRoute
  '/filenames/game-titles': typeof AuthedFilenamesGameTitlesRoute
  '/filenames/import': typeof AuthedFilenamesImportRoute
  '/filenames/players': typeof AuthedFilenamesPlayersRoute
  '/filenames/teams': typeof AuthedFilenamesTeamsRoute
  '/media-day/$date': typeof AuthedMediaDayDateRoute
  '/poses/qr-codes': typeof AuthedPosesQrCodesRoute
  '/poses/view': typeof AuthedPosesViewRoute
  '/setting/discord': typeof AuthedSettingDiscordRoute
  '/setting/schedule': typeof AuthedSettingScheduleRoute
  '/settings/scheduling': typeof AuthedSettingsSchedulingRoute
  '/staff-photo-shoots/$date': typeof AuthedStaffPhotoShootsDateRoute
  '/staff-photo-shoots/walk-ins': typeof AuthedStaffPhotoShootsWalkInsRoute
  '/users/allow-list': typeof AuthedUsersAllowListRoute
  '/users/manage': typeof AuthedUsersManageRoute
  '/media-day/status/$token': typeof MediaDayStatusTokenRoute
  '/scheduling/confirmed/$token': typeof SchedulingConfirmedTokenRoute
  '/fan-pics/': typeof AuthedFanPicsIndexRoute
  '/filenames/': typeof AuthedFilenamesIndexRoute
  '/users/': typeof AuthedUsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthedIndexRoute
  '/demo': typeof DemoRoute
  '/login': typeof LoginRoute
  '/call-times': typeof AuthedCallTimesRouteWithChildren
  '/ewc-calendar': typeof AuthedEwcCalendarRoute
  '/media-day': typeof AuthedMediaDayRouteWithChildren
  '/scanner-auth': typeof AuthedScannerAuthRoute
  '/staff-photo-shoots': typeof AuthedStaffPhotoShootsRouteWithChildren
  '/plama': typeof PlamaPlamaRoute
  '/scheduling/calendar': typeof SchedulingCalendarRoute
  '/scheduling/confirm': typeof SchedulingConfirmRoute
  '/scheduling': typeof SchedulingIndexRoute
  '/analytics/work-time': typeof AuthedAnalyticsWorkTimeRoute
  '/call-times/$date': typeof AuthedCallTimesDateRoute
  '/fan-pics/qr-codes': typeof AuthedFanPicsQrCodesRoute
  '/fan-pics/uploads': typeof AuthedFanPicsUploadsRoute
  '/filenames/game-titles': typeof AuthedFilenamesGameTitlesRoute
  '/filenames/import': typeof AuthedFilenamesImportRoute
  '/filenames/players': typeof AuthedFilenamesPlayersRoute
  '/filenames/teams': typeof AuthedFilenamesTeamsRoute
  '/media-day/$date': typeof AuthedMediaDayDateRoute
  '/poses/qr-codes': typeof AuthedPosesQrCodesRoute
  '/poses/view': typeof AuthedPosesViewRoute
  '/setting/discord': typeof AuthedSettingDiscordRoute
  '/setting/schedule': typeof AuthedSettingScheduleRoute
  '/settings/scheduling': typeof AuthedSettingsSchedulingRoute
  '/staff-photo-shoots/$date': typeof AuthedStaffPhotoShootsDateRoute
  '/staff-photo-shoots/walk-ins': typeof AuthedStaffPhotoShootsWalkInsRoute
  '/users/allow-list': typeof AuthedUsersAllowListRoute
  '/users/manage': typeof AuthedUsersManageRoute
  '/media-day/status/$token': typeof MediaDayStatusTokenRoute
  '/scheduling/confirmed/$token': typeof SchedulingConfirmedTokenRoute
  '/fan-pics': typeof AuthedFanPicsIndexRoute
  '/filenames': typeof AuthedFilenamesIndexRoute
  '/users': typeof AuthedUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/scheduling': typeof SchedulingRouteRouteWithChildren
  '/_authed': typeof AuthedRouteWithChildren
  '/_plama': typeof PlamaRouteWithChildren
  '/demo': typeof DemoRoute
  '/login': typeof LoginRoute
  '/_authed/fan-pics': typeof AuthedFanPicsRouteRouteWithChildren
  '/_authed/filenames': typeof AuthedFilenamesRouteRouteWithChildren
  '/_authed/users': typeof AuthedUsersRouteRouteWithChildren
  '/_authed/call-times': typeof AuthedCallTimesRouteWithChildren
  '/_authed/ewc-calendar': typeof AuthedEwcCalendarRoute
  '/_authed/media-day': typeof AuthedMediaDayRouteWithChildren
  '/_authed/scanner-auth': typeof AuthedScannerAuthRoute
  '/_authed/staff-photo-shoots': typeof AuthedStaffPhotoShootsRouteWithChildren
  '/_plama/plama': typeof PlamaPlamaRoute
  '/scheduling/calendar': typeof SchedulingCalendarRoute
  '/scheduling/confirm': typeof SchedulingConfirmRoute
  '/_authed/': typeof AuthedIndexRoute
  '/scheduling/': typeof SchedulingIndexRoute
  '/_authed/analytics/work-time': typeof AuthedAnalyticsWorkTimeRoute
  '/_authed/call-times/$date': typeof AuthedCallTimesDateRoute
  '/_authed/fan-pics/qr-codes': typeof AuthedFanPicsQrCodesRoute
  '/_authed/fan-pics/uploads': typeof AuthedFanPicsUploadsRoute
  '/_authed/filenames/game-titles': typeof AuthedFilenamesGameTitlesRoute
  '/_authed/filenames/import': typeof AuthedFilenamesImportRoute
  '/_authed/filenames/players': typeof AuthedFilenamesPlayersRoute
  '/_authed/filenames/teams': typeof AuthedFilenamesTeamsRoute
  '/_authed/media-day/$date': typeof AuthedMediaDayDateRoute
  '/_authed/poses/qr-codes': typeof AuthedPosesQrCodesRoute
  '/_authed/poses/view': typeof AuthedPosesViewRoute
  '/_authed/setting/discord': typeof AuthedSettingDiscordRoute
  '/_authed/setting/schedule': typeof AuthedSettingScheduleRoute
  '/_authed/settings/scheduling': typeof AuthedSettingsSchedulingRoute
  '/_authed/staff-photo-shoots/$date': typeof AuthedStaffPhotoShootsDateRoute
  '/_authed/staff-photo-shoots/walk-ins': typeof AuthedStaffPhotoShootsWalkInsRoute
  '/_authed/users/allow-list': typeof AuthedUsersAllowListRoute
  '/_authed/users/manage': typeof AuthedUsersManageRoute
  '/media-day/status/$token': typeof MediaDayStatusTokenRoute
  '/scheduling/confirmed/$token': typeof SchedulingConfirmedTokenRoute
  '/_authed/fan-pics/': typeof AuthedFanPicsIndexRoute
  '/_authed/filenames/': typeof AuthedFilenamesIndexRoute
  '/_authed/users/': typeof AuthedUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/scheduling'
    | '/'
    | '/demo'
    | '/login'
    | '/fan-pics'
    | '/filenames'
    | '/users'
    | '/call-times'
    | '/ewc-calendar'
    | '/media-day'
    | '/scanner-auth'
    | '/staff-photo-shoots'
    | '/plama'
    | '/scheduling/calendar'
    | '/scheduling/confirm'
    | '/scheduling/'
    | '/analytics/work-time'
    | '/call-times/$date'
    | '/fan-pics/qr-codes'
    | '/fan-pics/uploads'
    | '/filenames/game-titles'
    | '/filenames/import'
    | '/filenames/players'
    | '/filenames/teams'
    | '/media-day/$date'
    | '/poses/qr-codes'
    | '/poses/view'
    | '/setting/discord'
    | '/setting/schedule'
    | '/settings/scheduling'
    | '/staff-photo-shoots/$date'
    | '/staff-photo-shoots/walk-ins'
    | '/users/allow-list'
    | '/users/manage'
    | '/media-day/status/$token'
    | '/scheduling/confirmed/$token'
    | '/fan-pics/'
    | '/filenames/'
    | '/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/demo'
    | '/login'
    | '/call-times'
    | '/ewc-calendar'
    | '/media-day'
    | '/scanner-auth'
    | '/staff-photo-shoots'
    | '/plama'
    | '/scheduling/calendar'
    | '/scheduling/confirm'
    | '/scheduling'
    | '/analytics/work-time'
    | '/call-times/$date'
    | '/fan-pics/qr-codes'
    | '/fan-pics/uploads'
    | '/filenames/game-titles'
    | '/filenames/import'
    | '/filenames/players'
    | '/filenames/teams'
    | '/media-day/$date'
    | '/poses/qr-codes'
    | '/poses/view'
    | '/setting/discord'
    | '/setting/schedule'
    | '/settings/scheduling'
    | '/staff-photo-shoots/$date'
    | '/staff-photo-shoots/walk-ins'
    | '/users/allow-list'
    | '/users/manage'
    | '/media-day/status/$token'
    | '/scheduling/confirmed/$token'
    | '/fan-pics'
    | '/filenames'
    | '/users'
  id:
    | '__root__'
    | '/scheduling'
    | '/_authed'
    | '/_plama'
    | '/demo'
    | '/login'
    | '/_authed/fan-pics'
    | '/_authed/filenames'
    | '/_authed/users'
    | '/_authed/call-times'
    | '/_authed/ewc-calendar'
    | '/_authed/media-day'
    | '/_authed/scanner-auth'
    | '/_authed/staff-photo-shoots'
    | '/_plama/plama'
    | '/scheduling/calendar'
    | '/scheduling/confirm'
    | '/_authed/'
    | '/scheduling/'
    | '/_authed/analytics/work-time'
    | '/_authed/call-times/$date'
    | '/_authed/fan-pics/qr-codes'
    | '/_authed/fan-pics/uploads'
    | '/_authed/filenames/game-titles'
    | '/_authed/filenames/import'
    | '/_authed/filenames/players'
    | '/_authed/filenames/teams'
    | '/_authed/media-day/$date'
    | '/_authed/poses/qr-codes'
    | '/_authed/poses/view'
    | '/_authed/setting/discord'
    | '/_authed/setting/schedule'
    | '/_authed/settings/scheduling'
    | '/_authed/staff-photo-shoots/$date'
    | '/_authed/staff-photo-shoots/walk-ins'
    | '/_authed/users/allow-list'
    | '/_authed/users/manage'
    | '/media-day/status/$token'
    | '/scheduling/confirmed/$token'
    | '/_authed/fan-pics/'
    | '/_authed/filenames/'
    | '/_authed/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SchedulingRouteRoute: typeof SchedulingRouteRouteWithChildren
  AuthedRoute: typeof AuthedRouteWithChildren
  PlamaRoute: typeof PlamaRouteWithChildren
  DemoRoute: typeof DemoRoute
  LoginRoute: typeof LoginRoute
  MediaDayStatusTokenRoute: typeof MediaDayStatusTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_plama': {
      id: '/_plama'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PlamaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduling': {
      id: '/scheduling'
      path: '/scheduling'
      fullPath: '/scheduling'
      preLoaderRoute: typeof SchedulingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/call-times': {
      id: '/_authed/call-times'
      path: '/call-times'
      fullPath: '/call-times'
      preLoaderRoute: typeof AuthedCallTimesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ewc-calendar': {
      id: '/_authed/ewc-calendar'
      path: '/ewc-calendar'
      fullPath: '/ewc-calendar'
      preLoaderRoute: typeof AuthedEwcCalendarRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/fan-pics': {
      id: '/_authed/fan-pics'
      path: '/fan-pics'
      fullPath: '/fan-pics'
      preLoaderRoute: typeof AuthedFanPicsRouteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/filenames': {
      id: '/_authed/filenames'
      path: '/filenames'
      fullPath: '/filenames'
      preLoaderRoute: typeof AuthedFilenamesRouteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/media-day': {
      id: '/_authed/media-day'
      path: '/media-day'
      fullPath: '/media-day'
      preLoaderRoute: typeof AuthedMediaDayRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/scanner-auth': {
      id: '/_authed/scanner-auth'
      path: '/scanner-auth'
      fullPath: '/scanner-auth'
      preLoaderRoute: typeof AuthedScannerAuthRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/staff-photo-shoots': {
      id: '/_authed/staff-photo-shoots'
      path: '/staff-photo-shoots'
      fullPath: '/staff-photo-shoots'
      preLoaderRoute: typeof AuthedStaffPhotoShootsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/users': {
      id: '/_authed/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthedUsersRouteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_plama/plama': {
      id: '/_plama/plama'
      path: '/plama'
      fullPath: '/plama'
      preLoaderRoute: typeof PlamaPlamaRouteImport
      parentRoute: typeof PlamaRoute
    }
    '/scheduling/': {
      id: '/scheduling/'
      path: '/'
      fullPath: '/scheduling/'
      preLoaderRoute: typeof SchedulingIndexRouteImport
      parentRoute: typeof SchedulingRouteRoute
    }
    '/scheduling/calendar': {
      id: '/scheduling/calendar'
      path: '/calendar'
      fullPath: '/scheduling/calendar'
      preLoaderRoute: typeof SchedulingCalendarRouteImport
      parentRoute: typeof SchedulingRouteRoute
    }
    '/scheduling/confirm': {
      id: '/scheduling/confirm'
      path: '/confirm'
      fullPath: '/scheduling/confirm'
      preLoaderRoute: typeof SchedulingConfirmRouteImport
      parentRoute: typeof SchedulingRouteRoute
    }
    '/_authed/analytics/work-time': {
      id: '/_authed/analytics/work-time'
      path: '/analytics/work-time'
      fullPath: '/analytics/work-time'
      preLoaderRoute: typeof AuthedAnalyticsWorkTimeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/call-times/$date': {
      id: '/_authed/call-times/$date'
      path: '/$date'
      fullPath: '/call-times/$date'
      preLoaderRoute: typeof AuthedCallTimesDateRouteImport
      parentRoute: typeof AuthedCallTimesRoute
    }
    '/_authed/fan-pics/': {
      id: '/_authed/fan-pics/'
      path: '/'
      fullPath: '/fan-pics/'
      preLoaderRoute: typeof AuthedFanPicsIndexRouteImport
      parentRoute: typeof AuthedFanPicsRouteRoute
    }
    '/_authed/fan-pics/qr-codes': {
      id: '/_authed/fan-pics/qr-codes'
      path: '/qr-codes'
      fullPath: '/fan-pics/qr-codes'
      preLoaderRoute: typeof AuthedFanPicsQrCodesRouteImport
      parentRoute: typeof AuthedFanPicsRouteRoute
    }
    '/_authed/fan-pics/uploads': {
      id: '/_authed/fan-pics/uploads'
      path: '/uploads'
      fullPath: '/fan-pics/uploads'
      preLoaderRoute: typeof AuthedFanPicsUploadsRouteImport
      parentRoute: typeof AuthedFanPicsRouteRoute
    }
    '/_authed/filenames/': {
      id: '/_authed/filenames/'
      path: '/'
      fullPath: '/filenames/'
      preLoaderRoute: typeof AuthedFilenamesIndexRouteImport
      parentRoute: typeof AuthedFilenamesRouteRoute
    }
    '/_authed/filenames/game-titles': {
      id: '/_authed/filenames/game-titles'
      path: '/game-titles'
      fullPath: '/filenames/game-titles'
      preLoaderRoute: typeof AuthedFilenamesGameTitlesRouteImport
      parentRoute: typeof AuthedFilenamesRouteRoute
    }
    '/_authed/filenames/import': {
      id: '/_authed/filenames/import'
      path: '/import'
      fullPath: '/filenames/import'
      preLoaderRoute: typeof AuthedFilenamesImportRouteImport
      parentRoute: typeof AuthedFilenamesRouteRoute
    }
    '/_authed/filenames/players': {
      id: '/_authed/filenames/players'
      path: '/players'
      fullPath: '/filenames/players'
      preLoaderRoute: typeof AuthedFilenamesPlayersRouteImport
      parentRoute: typeof AuthedFilenamesRouteRoute
    }
    '/_authed/filenames/teams': {
      id: '/_authed/filenames/teams'
      path: '/teams'
      fullPath: '/filenames/teams'
      preLoaderRoute: typeof AuthedFilenamesTeamsRouteImport
      parentRoute: typeof AuthedFilenamesRouteRoute
    }
    '/_authed/media-day/$date': {
      id: '/_authed/media-day/$date'
      path: '/$date'
      fullPath: '/media-day/$date'
      preLoaderRoute: typeof AuthedMediaDayDateRouteImport
      parentRoute: typeof AuthedMediaDayRoute
    }
    '/_authed/poses/qr-codes': {
      id: '/_authed/poses/qr-codes'
      path: '/poses/qr-codes'
      fullPath: '/poses/qr-codes'
      preLoaderRoute: typeof AuthedPosesQrCodesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/poses/view': {
      id: '/_authed/poses/view'
      path: '/poses/view'
      fullPath: '/poses/view'
      preLoaderRoute: typeof AuthedPosesViewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/setting/discord': {
      id: '/_authed/setting/discord'
      path: '/setting/discord'
      fullPath: '/setting/discord'
      preLoaderRoute: typeof AuthedSettingDiscordRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/setting/schedule': {
      id: '/_authed/setting/schedule'
      path: '/setting/schedule'
      fullPath: '/setting/schedule'
      preLoaderRoute: typeof AuthedSettingScheduleRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/scheduling': {
      id: '/_authed/settings/scheduling'
      path: '/settings/scheduling'
      fullPath: '/settings/scheduling'
      preLoaderRoute: typeof AuthedSettingsSchedulingRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/staff-photo-shoots/$date': {
      id: '/_authed/staff-photo-shoots/$date'
      path: '/$date'
      fullPath: '/staff-photo-shoots/$date'
      preLoaderRoute: typeof AuthedStaffPhotoShootsDateRouteImport
      parentRoute: typeof AuthedStaffPhotoShootsRoute
    }
    '/_authed/staff-photo-shoots/walk-ins': {
      id: '/_authed/staff-photo-shoots/walk-ins'
      path: '/walk-ins'
      fullPath: '/staff-photo-shoots/walk-ins'
      preLoaderRoute: typeof AuthedStaffPhotoShootsWalkInsRouteImport
      parentRoute: typeof AuthedStaffPhotoShootsRoute
    }
    '/_authed/users/': {
      id: '/_authed/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthedUsersIndexRouteImport
      parentRoute: typeof AuthedUsersRouteRoute
    }
    '/_authed/users/allow-list': {
      id: '/_authed/users/allow-list'
      path: '/allow-list'
      fullPath: '/users/allow-list'
      preLoaderRoute: typeof AuthedUsersAllowListRouteImport
      parentRoute: typeof AuthedUsersRouteRoute
    }
    '/_authed/users/manage': {
      id: '/_authed/users/manage'
      path: '/manage'
      fullPath: '/users/manage'
      preLoaderRoute: typeof AuthedUsersManageRouteImport
      parentRoute: typeof AuthedUsersRouteRoute
    }
    '/media-day/status/$token': {
      id: '/media-day/status/$token'
      path: '/media-day/status/$token'
      fullPath: '/media-day/status/$token'
      preLoaderRoute: typeof MediaDayStatusTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduling/confirmed/$token': {
      id: '/scheduling/confirmed/$token'
      path: '/confirmed/$token'
      fullPath: '/scheduling/confirmed/$token'
      preLoaderRoute: typeof SchedulingConfirmedTokenRouteImport
      parentRoute: typeof SchedulingRouteRoute
    }
  }
}

interface SchedulingRouteRouteChildren {
  SchedulingCalendarRoute: typeof SchedulingCalendarRoute
  SchedulingConfirmRoute: typeof SchedulingConfirmRoute
  SchedulingIndexRoute: typeof SchedulingIndexRoute
  SchedulingConfirmedTokenRoute: typeof SchedulingConfirmedTokenRoute
}

const SchedulingRouteRouteChildren: SchedulingRouteRouteChildren = {
  SchedulingCalendarRoute: SchedulingCalendarRoute,
  SchedulingConfirmRoute: SchedulingConfirmRoute,
  SchedulingIndexRoute: SchedulingIndexRoute,
  SchedulingConfirmedTokenRoute: SchedulingConfirmedTokenRoute,
}

const SchedulingRouteRouteWithChildren = SchedulingRouteRoute._addFileChildren(
  SchedulingRouteRouteChildren,
)

interface AuthedFanPicsRouteRouteChildren {
  AuthedFanPicsQrCodesRoute: typeof AuthedFanPicsQrCodesRoute
  AuthedFanPicsUploadsRoute: typeof AuthedFanPicsUploadsRoute
  AuthedFanPicsIndexRoute: typeof AuthedFanPicsIndexRoute
}

const AuthedFanPicsRouteRouteChildren: AuthedFanPicsRouteRouteChildren = {
  AuthedFanPicsQrCodesRoute: AuthedFanPicsQrCodesRoute,
  AuthedFanPicsUploadsRoute: AuthedFanPicsUploadsRoute,
  AuthedFanPicsIndexRoute: AuthedFanPicsIndexRoute,
}

const AuthedFanPicsRouteRouteWithChildren =
  AuthedFanPicsRouteRoute._addFileChildren(AuthedFanPicsRouteRouteChildren)

interface AuthedFilenamesRouteRouteChildren {
  AuthedFilenamesGameTitlesRoute: typeof AuthedFilenamesGameTitlesRoute
  AuthedFilenamesImportRoute: typeof AuthedFilenamesImportRoute
  AuthedFilenamesPlayersRoute: typeof AuthedFilenamesPlayersRoute
  AuthedFilenamesTeamsRoute: typeof AuthedFilenamesTeamsRoute
  AuthedFilenamesIndexRoute: typeof AuthedFilenamesIndexRoute
}

const AuthedFilenamesRouteRouteChildren: AuthedFilenamesRouteRouteChildren = {
  AuthedFilenamesGameTitlesRoute: AuthedFilenamesGameTitlesRoute,
  AuthedFilenamesImportRoute: AuthedFilenamesImportRoute,
  AuthedFilenamesPlayersRoute: AuthedFilenamesPlayersRoute,
  AuthedFilenamesTeamsRoute: AuthedFilenamesTeamsRoute,
  AuthedFilenamesIndexRoute: AuthedFilenamesIndexRoute,
}

const AuthedFilenamesRouteRouteWithChildren =
  AuthedFilenamesRouteRoute._addFileChildren(AuthedFilenamesRouteRouteChildren)

interface AuthedUsersRouteRouteChildren {
  AuthedUsersAllowListRoute: typeof AuthedUsersAllowListRoute
  AuthedUsersManageRoute: typeof AuthedUsersManageRoute
  AuthedUsersIndexRoute: typeof AuthedUsersIndexRoute
}

const AuthedUsersRouteRouteChildren: AuthedUsersRouteRouteChildren = {
  AuthedUsersAllowListRoute: AuthedUsersAllowListRoute,
  AuthedUsersManageRoute: AuthedUsersManageRoute,
  AuthedUsersIndexRoute: AuthedUsersIndexRoute,
}

const AuthedUsersRouteRouteWithChildren =
  AuthedUsersRouteRoute._addFileChildren(AuthedUsersRouteRouteChildren)

interface AuthedCallTimesRouteChildren {
  AuthedCallTimesDateRoute: typeof AuthedCallTimesDateRoute
}

const AuthedCallTimesRouteChildren: AuthedCallTimesRouteChildren = {
  AuthedCallTimesDateRoute: AuthedCallTimesDateRoute,
}

const AuthedCallTimesRouteWithChildren = AuthedCallTimesRoute._addFileChildren(
  AuthedCallTimesRouteChildren,
)

interface AuthedMediaDayRouteChildren {
  AuthedMediaDayDateRoute: typeof AuthedMediaDayDateRoute
}

const AuthedMediaDayRouteChildren: AuthedMediaDayRouteChildren = {
  AuthedMediaDayDateRoute: AuthedMediaDayDateRoute,
}

const AuthedMediaDayRouteWithChildren = AuthedMediaDayRoute._addFileChildren(
  AuthedMediaDayRouteChildren,
)

interface AuthedStaffPhotoShootsRouteChildren {
  AuthedStaffPhotoShootsDateRoute: typeof AuthedStaffPhotoShootsDateRoute
  AuthedStaffPhotoShootsWalkInsRoute: typeof AuthedStaffPhotoShootsWalkInsRoute
}

const AuthedStaffPhotoShootsRouteChildren: AuthedStaffPhotoShootsRouteChildren =
  {
    AuthedStaffPhotoShootsDateRoute: AuthedStaffPhotoShootsDateRoute,
    AuthedStaffPhotoShootsWalkInsRoute: AuthedStaffPhotoShootsWalkInsRoute,
  }

const AuthedStaffPhotoShootsRouteWithChildren =
  AuthedStaffPhotoShootsRoute._addFileChildren(
    AuthedStaffPhotoShootsRouteChildren,
  )

interface AuthedRouteChildren {
  AuthedFanPicsRouteRoute: typeof AuthedFanPicsRouteRouteWithChildren
  AuthedFilenamesRouteRoute: typeof AuthedFilenamesRouteRouteWithChildren
  AuthedUsersRouteRoute: typeof AuthedUsersRouteRouteWithChildren
  AuthedCallTimesRoute: typeof AuthedCallTimesRouteWithChildren
  AuthedEwcCalendarRoute: typeof AuthedEwcCalendarRoute
  AuthedMediaDayRoute: typeof AuthedMediaDayRouteWithChildren
  AuthedScannerAuthRoute: typeof AuthedScannerAuthRoute
  AuthedStaffPhotoShootsRoute: typeof AuthedStaffPhotoShootsRouteWithChildren
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedAnalyticsWorkTimeRoute: typeof AuthedAnalyticsWorkTimeRoute
  AuthedPosesQrCodesRoute: typeof AuthedPosesQrCodesRoute
  AuthedPosesViewRoute: typeof AuthedPosesViewRoute
  AuthedSettingDiscordRoute: typeof AuthedSettingDiscordRoute
  AuthedSettingScheduleRoute: typeof AuthedSettingScheduleRoute
  AuthedSettingsSchedulingRoute: typeof AuthedSettingsSchedulingRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedFanPicsRouteRoute: AuthedFanPicsRouteRouteWithChildren,
  AuthedFilenamesRouteRoute: AuthedFilenamesRouteRouteWithChildren,
  AuthedUsersRouteRoute: AuthedUsersRouteRouteWithChildren,
  AuthedCallTimesRoute: AuthedCallTimesRouteWithChildren,
  AuthedEwcCalendarRoute: AuthedEwcCalendarRoute,
  AuthedMediaDayRoute: AuthedMediaDayRouteWithChildren,
  AuthedScannerAuthRoute: AuthedScannerAuthRoute,
  AuthedStaffPhotoShootsRoute: AuthedStaffPhotoShootsRouteWithChildren,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedAnalyticsWorkTimeRoute: AuthedAnalyticsWorkTimeRoute,
  AuthedPosesQrCodesRoute: AuthedPosesQrCodesRoute,
  AuthedPosesViewRoute: AuthedPosesViewRoute,
  AuthedSettingDiscordRoute: AuthedSettingDiscordRoute,
  AuthedSettingScheduleRoute: AuthedSettingScheduleRoute,
  AuthedSettingsSchedulingRoute: AuthedSettingsSchedulingRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface PlamaRouteChildren {
  PlamaPlamaRoute: typeof PlamaPlamaRoute
}

const PlamaRouteChildren: PlamaRouteChildren = {
  PlamaPlamaRoute: PlamaPlamaRoute,
}

const PlamaRouteWithChildren = PlamaRoute._addFileChildren(PlamaRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  SchedulingRouteRoute: SchedulingRouteRouteWithChildren,
  AuthedRoute: AuthedRouteWithChildren,
  PlamaRoute: PlamaRouteWithChildren,
  DemoRoute: DemoRoute,
  LoginRoute: LoginRoute,
  MediaDayStatusTokenRoute: MediaDayStatusTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
